import { render } from "./CustomerBuildingList.vue?vue&type=template&id=70ce9f78&scoped=true"
import script from "./CustomerBuildingList.vue?vue&type=script&lang=js"
export * from "./CustomerBuildingList.vue?vue&type=script&lang=js"

import "./CustomerBuildingList.vue?vue&type=style&index=0&id=70ce9f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ce9f78"]])

export default __exports__